import { createInstance, Identify } from '@amplitude/analytics-browser'

const amplitudeInstance = createInstance()

export const initAmplitude = () => {
  amplitudeInstance.init(process.env.VUE_APP_AMPLITUDE)
}

export const trackUserLogin = ({ userId, email, financial }) => {
  amplitudeInstance.setUserId(userId)

  const identify = new Identify()
  identify.set('email', email)
  identify.set('financial', financial)

  amplitudeInstance.identify(identify)

  amplitudeInstance.track('user_login', {
    user_id: userId,
    email,
    financial
  })
}

export const trackPageView = ({ routeName, routePath, financial, userId, role }) => {
  amplitudeInstance.setUserId(userId)

  const identify = new Identify()
  identify.set('role', role)
  amplitudeInstance.identify(identify)

  amplitudeInstance.track('page_view', {
    route_name: routeName,
    route_path: routePath,
    financial: financial,
    user_id: userId
  })
}

export default amplitudeInstance
